import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useMsal } from '@azure/msal-react';
import { TokenHelper } from '../../TokenHelper';
import { TeamsState } from '../../store/TeamsState';
import { useEditorStyles } from '../Styles/Editor';
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Field, Label, Link, Switch, SwitchOnChangeData, Toast, ToastTitle, ToastTrigger, useToastController } from '@fluentui/react-components';
import { ConsultantActionCreators } from '../../store/consultants';
import { useTranslation } from 'react-i18next';

export const PeppolReceivedDocsDeleteConfirm = () => {
    // All data needed for edition should be loaded before calling the editor
    const consultantPeppolReceivedInvoicedeletion = useSelector((state: ApplicationState) => state.consultantsState.consultantPeppolReceivedInvoicedeletion);
    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);
    // Gen hooks
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const styles = useEditorStyles();
    const { dispatchToast, updateToast } = useToastController("NeoToasterUnique");
    const { t } = useTranslation();
    // Form validation
    const [confirmDelete, setConfirmDelete] = React.useState(false);

    if (consultantPeppolReceivedInvoicedeletion === null) {
        return <></>;
    }

    const submit = () => {
        TokenHelper.GetToken(instance, teamsState)
            .then(token => {
                if (token !== null) {
                    const toastId = (Math.random() + 1).toString(36).substring(7);
                    dispatchToast(
                        <Toast appearance="inverted">
                            <ToastTitle>
                                Deleting Document...
                            </ToastTitle>
                        </Toast>,
                        { intent: "info", timeout: -1, position: "top-end", toastId: toastId }
                    );
                    fetch("api/PeppolReceivedInvoices/" + (consultantPeppolReceivedInvoicedeletion && consultantPeppolReceivedInvoicedeletion.peppolReceivedInvoiceId !== null ? consultantPeppolReceivedInvoicedeletion.peppolReceivedInvoiceId : ""), {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: "bearer " + token,
                        },
                        mode: "cors",
                        cache: "default",
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 204) {
                                updateToast({
                                    content: (
                                        <Toast appearance="inverted">
                                            <ToastTitle action={
                                                <ToastTrigger>
                                                    <Link>Dismiss</Link>
                                                </ToastTrigger>
                                            }>
                                                Document deleted
                                            </ToastTitle>
                                        </Toast>
                                    ),
                                    intent: "success",
                                    toastId,
                                    timeout: 5000,
                                });
                                if (consultantPeppolReceivedInvoicedeletion) dispatch(ConsultantActionCreators.patchConsultantPeppolReceivedInvoiceDeletionEdition(consultantPeppolReceivedInvoicedeletion));
                                dispatch(ConsultantActionCreators.requestConsultantPeppolReceivedInvoicedeletion(null));
                            }
                            else {
                                updateToast({
                                    content: (
                                        <Toast appearance="inverted">
                                            <ToastTitle action={
                                                <ToastTrigger>
                                                    <Link>Dismiss</Link>
                                                </ToastTrigger>
                                            }>
                                                Document delete failed
                                            </ToastTitle>
                                        </Toast>
                                    ),
                                    intent: "error",
                                    toastId,
                                    timeout: 10000,
                                });
                            }
                        });
                }
            });
    };

    return <Dialog
        open
        modalType="modal">
        <DialogSurface>
            <DialogBody>
                <DialogTitle>Delete peppol received document</DialogTitle>
                <DialogContent>
                    <form
                        onSubmit={() => {
                            dispatch(ConsultantActionCreators.requestConsultantPeppolReceivedInvoicedeletion(null));
                        }}
                        autoComplete="off"
                    >
                        <Field label="Date">
                            <Label className={styles.label}>{consultantPeppolReceivedInvoicedeletion.issueDate ? new Date(consultantPeppolReceivedInvoicedeletion.issueDate).toLocaleDateString() : "-"}</Label>
                        </Field>
                        <Field label="Source">
                            <Label className={styles.label}>{consultantPeppolReceivedInvoicedeletion.registrationName !== null ? consultantPeppolReceivedInvoicedeletion.registrationName : ""}</Label>
                        </Field>
                        <Field label="Amount">
                            <Label className={styles.label}>{consultantPeppolReceivedInvoicedeletion.payableAmount ? consultantPeppolReceivedInvoicedeletion.payableAmount.toLocaleString(undefined, { style: 'currency', currency: 'EUR' }) : "-"}</Label>
                        </Field>
                        <Field label="Description">
                            <Label className={styles.label}>{consultantPeppolReceivedInvoicedeletion.description !== null ? consultantPeppolReceivedInvoicedeletion.description : ""}</Label>
                        </Field>
                        <Switch checked={confirmDelete} label="Confirm deletion" onChange={(ev: React.ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => { setConfirmDelete(data.checked); }} />
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => dispatch(ConsultantActionCreators.requestConsultantPeppolReceivedInvoicedeletion(null))}
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        onClick={() => submit()}
                        type="submit"
                        form="my-form-id"
                        appearance="primary"
                        disabled={!confirmDelete}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>;
};